<template>
  <div class="house-content">
    <div class="flex align-it-cen jus-con-bet bg-white statistic mg-b-20">
      <span>可视区域内为您找到<span class="map-font-theme">288</span>套可租房</span>
      <span>
        <a-icon @click="show = !show" v-if="!show" type="down" />
        <a-icon @click="show = !show" v-else type="up" />
      </span>
    </div>
    <div class="bg-white house-list" v-if="show">
      <div class="flex align-it-cen jus-con-bet tabel-header">
        <div class="flex align-it-cen" v-for="(el, i) of filterActions" :key="i">
          <span>{{ el.label }}</span>
          <div class="flex flex-column align-it-cen" v-if="el.show">
            <a-icon type="caret-up" :class="{ 'map-font-theme': el.sort == 'up' }" />
            <a-icon type="caret-down" :class="{ 'map-font-theme': el.sort == 'down' }" />
          </div>
        </div>
      </div>
      <div
        v-infinite-scroll="handleInfiniteOnLoad"
        class="infinite-container"
        :infinite-scroll-disabled="busy"
        :infinite-scroll-distance="10"
      >
        <a-list :data-source="tableData">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <div class="flex align-it-cen">
              <div class="mg-r-10">
                <img
                  width="76px"
                  height="57px"
                  src="https://gysy-web.obs.cn-north-4.myhuaweicloud.com/CORP/2d30974463f74ccfbd8084234e18a2eb.jpg"
                  alt=""
                />
              </div>
              <div>
                <div>万达入口转角带外摆餐饮铺直租</div>
                <small> 建: 80.98m², 实: 120.00m² </small>
                <div class="money">23000.00元/月</div>
              </div>
            </div>
          </a-list-item>
          <div v-if="loading" class="loading-container">
            <a-spin />
          </div>
        </a-list>
      </div>
      <!-- <u-table
        ref="plTable"
        :data="tableData"
        :height="height"
        use-virtual
        showBodyOverflow="ellipsis"
        :show-header="false"
        :row-height="rowHeight"
        :border="false"
        @table-body-scroll="tableScroll"
      >
        <u-table-column>
          <div class="flex align-it-cen">
            <div class="mg-r-10">
              <img
                width="76px"
                height="57px"
                src="https://gysy-web.obs.cn-north-4.myhuaweicloud.com/CORP/2d30974463f74ccfbd8084234e18a2eb.jpg"
                alt=""
              />
            </div>
            <div>
              <div>万达入口转角带外摆餐饮铺直租</div>
              <small> 建: 80.98m², 实: 120.00m² </small>
              <div class="money">23000.00元/月</div>
            </div>
          </div>
        </u-table-column>
      </u-table> -->
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
export default {
  directives: { infiniteScroll },
  data() {
    return {
      busy: false,
      loading:false, // 加载
      show: false, // 显示房源列表
      //   列表数据
      tableData: [],
      height: 400, // 表格高度
      rowHeight: 55,
      //   表头
      filterActions: [
        { label: '综合', value: '1', show: false, onclick: () => {} },
        { label: '面积', value: '2', show: true, sort: '', onclick: () => {} },
        { label: '单价', value: '3', show: true, sort: '', onclick: () => {} },
        { label: '带看', value: '4', show: true, sort: '', onclick: () => {} },
        { label: '盘别', value: '5', show: true, sort: '', onclick: () => {} },
      ],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 获取数据
    getList() {
      for (let i = 0; i <= 10; i++) {
        this.tableData.push({ id: i })
      }
    },
    // 表格滚动监听
    tableScroll(e) {
      console.log(e, '2')
    },
    handleInfiniteOnLoad() {
      this.busy = true
      this.loading = true
      setTimeout(() => {
        for (let i = 0; i <= 10; i++) {
          this.tableData.push({ id: this.tableData.length  + i })
        }
        this.busy = false
        this.loading = false
      }, 1000)
    },
  },
}
</script>

<style lang="less" scoped>
.house-content {
  width: 326px;
  position: absolute;
  left: 0px;
  top: 100px;
}
.statistic {
  height: 43px;
  padding: 0 13px 0 20px;
}
.house-list {
  padding: 0 13px 0 20px;
}
.tabel-header {
  height: 38px;
}
.infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 530px;
}
.loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
</style>
